import { render, staticRenderFns } from "./ListReceiver.vue?vue&type=template&id=9cd2c78a&scoped=true"
import script from "./ListReceiver.vue?vue&type=script&lang=js"
export * from "./ListReceiver.vue?vue&type=script&lang=js"
import style0 from "./ListReceiver.vue?vue&type=style&index=0&id=9cd2c78a&lang=css"
import style1 from "./ListReceiver.vue?vue&type=style&index=1&id=9cd2c78a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cd2c78a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9cd2c78a')) {
      api.createRecord('9cd2c78a', component.options)
    } else {
      api.reload('9cd2c78a', component.options)
    }
    module.hot.accept("./ListReceiver.vue?vue&type=template&id=9cd2c78a&scoped=true", function () {
      api.rerender('9cd2c78a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/notifihistory/ListReceiver.vue"
export default component.exports